/* eslint-disable no-undef */
import $ from 'jquery';

/** Class representing a video player Wrapper. */
class VideoPlayerWrapper {
  /**
   * video player wrapper class.
   * @class
   */
  constructor() {
    this.jwPlayers = [];
    this.ytPlayers = [];
    window.dataLayer = window.dataLayer || [];
    this.dataLayer = window.dataLayer;
    this.videoInterval = null;
  }

  /**
   * Initialize JW Player or YT player on elements with '.video-wrapper' class.
   * Can be initialized with options via data-attributes using the prefix data-video-
   * 	mute="0/1",
   * 	controls="0/1",
   * 	autoplay="0/1",
   * 	loop="0/1",
   * @param {Boolean} isConsentAccepted
   * @void
   */
  initVideo(isConsentAccepted = false) {
    /**
     * On Youtube Player ready function to set the Mute and Loop properties
     * @param {*} event - Event containing a player reference (event.target)
     * @param {Number} mute - 1/0 translate-able to boolean. 1 - Video is muted. 0 - Video has audio
     * @param {Number} loop - 1/0 translate-able to boolean. 1 - Video plays on a loop.
     * 0 - Video Plays once
     */
    const onPlayerReady = (event, mute, loop, autoplay) => {
      if (mute) {
        event.target.mute();
      }
      event.target.setLoop(loop === 1);
      if (autoplay === 1) {
        event.target.playVideo();
      }
    };

    /**
     *
     * @param {*} event - Event containing a player reference (event.target)
     * @param {DOM element} overlayEnd - Dom node for Overlay element at the end of the video
     * @param {DOM element} playBtn - Dom node for Overlay element at the end of the video
     * @param {Number} loop - 1/0 translate-able to boolean. 1 - Video plays on a loop.
     * 0 - Video Plays once
     */
    const onPlayerStateChange = (event, overlayEnd, playBtn, loop, player) => {
      if (!player.videoCompletion) {
        player.videoCompletion = [];
      }

      if (event.data === YT.PlayerState.PLAYING) {
        // Sending data depending on milesone (25%, 50% and 75%)
        player.videoInterval = setInterval(() => {
          const currentTime = event.target.getCurrentTime(); // get video position
          const videoDuration = event.target.getDuration(); // get video duration
          let percentageVideo = (currentTime / videoDuration) * 100; // calculate % complete
          percentageVideo = Math.round(percentageVideo); // round to a whole number

          if (percentageVideo >= 25 && percentageVideo < 50 && !player.videoCompletion['25']) {
            this.dataLayer.push({
              event: 'ga4_video_progress',
              ga4_data: {
                video_provider: 'YouTube',
                video_title: event.target.videoTitle,
                video_url: event.target.getVideoUrl(),
                video_percent: 25,
                video_duration: event.target.getDuration(),
                visible: 1,
              },
            });

            player.videoCompletion['25'] = true;
          } else if (percentageVideo >= 50 && percentageVideo < 75 && !player.videoCompletion['50']) {
            this.dataLayer.push({
              event: 'ga4_video_progress',
              ga4_data: {
                video_provider: 'YouTube',
                video_title: event.target.videoTitle,
                video_url: event.target.getVideoUrl(),
                video_percent: 50,
                video_duration: event.target.getDuration(),
                visible: 1,
              },
            });

            player.videoCompletion['50'] = true;
          } else if (percentageVideo >= 75 && percentageVideo < 100 && !player.videoCompletion['75']) {
            this.dataLayer.push({
              event: 'ga4_video_progress',
              ga4_data: {
                video_provider: 'YouTube',
                video_title: event.target.videoTitle,
                video_url: event.target.getVideoUrl(),
                video_percent: 75,
                video_duration: event.target.getDuration(),
                visible: 1,
              },
            });

            player.videoCompletion['75'] = true;
          }
        }, 2000);

        // Push datalayer video start data (youtube)
        if (!player.initialPlay) {
          this.dataLayer.push({
            event: 'ga4_video_start',
            ga4_data: {
              video_provider: 'YouTube',
              video_title: event.target.videoTitle,
              video_url: event.target.getVideoUrl(),
              video_percent: 0,
              video_duration: event.target.getDuration(),
              visible: 1,
            },
          });
        }

        player.initialPlay = true;
      } else {
        clearInterval(player.videoInterval);
      }

      if (event.data === YT.PlayerState.ENDED) {
        if (overlayEnd && loop !== 1) {
          overlayEnd.classList.add('is-visible');
          playBtn.classList.add('is-visible');
        }

        this.dataLayer.push({
          event: 'ga4_video_complete',
          ga4_data: {
            video_provider: 'YouTube',
            video_title: event.target.videoTitle,
            video_url: event.target.getVideoUrl(),
            video_percent: 0,
            video_duration: event.target.getDuration(),
            visible: 1,
          },
        });
      }
    };

    const playerWrappers = document.querySelectorAll('.video-wrapper');
    const JWPlayerElements = [];
    const YTPlayerElements = [];

    for (let i = 0; i < playerWrappers.length; i += 1) {
      const wrapperElem = playerWrappers[i];
      const playerElement = wrapperElem.querySelectorAll('.video-player')[0];
      if (playerElement) {
        const playerTypeYT = playerElement.dataset.videoPlayerType === 'youtube';
        // Get player options
        const autoplay = parseInt(playerElement.dataset.videoAutoplay, 10);
        const controls = parseInt(playerElement.dataset.videoControls, 10);
        const loop = parseInt(playerElement.dataset.videoLoop, 10);
        const mute = parseInt(playerElement.dataset.videoMute, 10);
        // Get overlay elements
        const playBtn = wrapperElem.querySelectorAll('.play-btn')[0];
        const overlayStart = wrapperElem.querySelectorAll('.overlay-start')[0];
        const overlayEnd = wrapperElem.querySelectorAll('.overlay-end')[0];

        const options = {
          autoplay,
          controls,
          loop,
          mute,
          playBtn,
          overlayStart,
          overlayEnd,
        };

        if (playerTypeYT) {
          YTPlayerElements.push({
            playerElement,
            options,
          });
        } else {
          JWPlayerElements.push({
            playerElement,
            options,
          });
        }
      }
    }

    if (YTPlayerElements.length && isConsentAccepted) {
      this.ytPlayers = [];
      $.getScript('https://www.youtube.com/iframe_api', () => {
        window.YT.ready(() => {
          YTPlayerElements.forEach((playerOption) => {
            let player = null;
            const {
              playerElement,
              options: {
                controls,
                mute,
                loop,
                autoplay,
                overlayStart,
                overlayEnd,
                playBtn,
              },
            } = playerOption;

            const { videoId } = playerElement.dataset;

            player = new YT.Player(playerElement, {
              width: 'auto',
              height: 'auto',
              playerVars: {
                playlist: videoId,
                controls,
                rel: 0,
              },
              events: {
                onReady: (event) => onPlayerReady(event, mute, loop, autoplay),
                onStateChange: (event) => onPlayerStateChange(event, overlayEnd, playBtn, loop, player),
              },
            });
            player.initialPlay = false;

            this.ytPlayers.push(player);
            if (playBtn) {
              playBtn.addEventListener('click', () => {
                // If there is overlay on start of the video
                if (overlayStart) {
                  overlayStart.classList.remove('is-visible');

                  // If there is overlay on end of the video
                  if (overlayEnd) {
                    overlayEnd.classList.remove('is-visible');
                  }
                }
                playBtn.classList.remove('is-visible');
                player.playVideo();
              });
            }
          });
        });
      });
    }

    if (JWPlayerElements.length) {
      JWPlayerElements.forEach((playerOption) => {
        let player = null;
        const {
          playerElement,
          options: {
            controls,
            mute,
            loop,
            autoplay,
            overlayEnd,
            overlayStart,
            playBtn,
          },
        } = playerOption;

        player = new VideoPlayer(playerElement);

        // When player is ready we are initializing it with configuration
        // jwplayer is not imported but instead included in the page
        let currentPlay;
        player.jwplayer.on('ready', () => {
          player.jwplayer.setControls(controls === 1);
          player.jwplayer.setConfig({
            stretching: 'fill',
            mute: mute === 1,
            repeat: loop === 1,
            title: '',
          });
          currentPlay = 0;

          if (autoplay === 1) {
            player.jwplayer.play();
          }
        }).on('complete', () => {
          if (overlayEnd && loop !== 1) {
            overlayEnd.classList.add('is-visible');
            playBtn.classList.add('is-visible');
          }
          if (player.element.classList.contains('js-loop-3')) {
            if (currentPlay >= 2) { // stop player after 3 loops
              player.jwplayer.stop();
            }
            currentPlay += 1;
          }
        });

        this.jwPlayers.push(player);
        if (playBtn) {
          playBtn.addEventListener('click', () => {
            // https://docs.jwplayer.com/players/reference/playback-events-1#onfirstframe
            player.jwplayer.on('firstFrame', () => {
              // If there is overlay on start of the video
              if (overlayStart) {
                overlayStart.classList.remove('is-visible');
              }

              // If there is overlay on end of the video
              if (overlayEnd) {
                overlayEnd.classList.remove('is-visible');
              }
            });

            playBtn.classList.remove('is-visible');
            player.play();
          });
        }
      });
    }
  }

  /**
   * Get all player instances
   * @returns {Array} Array of players
   */
  getPlayers() {
    return {
      JW: this.jwPlayers,
      YT: this.ytPlayers,
    };
  }
}
const videoPlayerWrapper = new VideoPlayerWrapper();
export default videoPlayerWrapper;
